import { Burger } from './burger.js';
import { StickyHeader } from './sticky-header.js';

const breakpoint = 768;

export const initMenu = function() {
  const header = document.querySelector('[data-header]');
  const overlay = document.querySelector('[data-overlay]');
  const overlayNav = document.querySelector('[data-nav-overlay]');
  const overlayCatalog = document.querySelector('[data-catalog-overlay]');
  const overlayFilter = document.querySelector('[data-filter-overlay]');
  const burger = new Burger('[data-header]', '[data-burger]', overlay);
  const burger2 = new Burger('[data-header]', '[data-burger-footer]', overlay);
  const burgerNav = new Burger('[data-nav="menu"]', '[data-nav="burger"]', overlayNav);
  const burgerCatalog = new Burger('[data-catalog="menu"]', '[data-catalog="burger"]', overlayCatalog);
  const burgerFilter = new Burger('[data-filter="menu"]', '[data-filter="burger"]', overlayFilter);

  const startMenu = () => {
    burger.init();
    burger2.init();
    burgerNav.init();
    if (breakpoint <= window.innerWidth) {
      burgerCatalog.init();
    }
    burgerFilter.init();
    burger.setHeight();
    burger2.setHeight();
    const stickyHeader = new StickyHeader();
    stickyHeader.init();

    overlay.addEventListener('click', onOverlayClose);
  }

  const closeMenu = () => {
    burger._closeMenu();
    burger2._closeMenu();
    burgerNav._closeMenu();
    if (breakpoint <= window.innerWidth) {
      burgerCatalog._closeMenu();
    }
    burgerFilter._closeMenu();
  }

  const onOverlayClose = (evt) => {
    evt.preventDefault();

    let target = evt.target;
    if (target === overlay) {
      closeMenu();
    }
  };

  if (!header) {
    return;
  }

  startMenu();
  closeMenu();
};
